module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('BlogList'), _vm._v(" "), _vm._c('AdBlock', {
    attrs: {
      "slot-id": 1,
      "count": 1,
      "containerClass": 'container xs-pb-30',
      "ad-area-override": "public"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70922982!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/home/BlogPage.vue
// module id = 682
// module chunks = 1